'use strict';

var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var utils = require('./utils');
var _require = require('./Error'),
  StripeError = _require.StripeError;
var StreamProcessingError = /*#__PURE__*/function (_StripeError) {
  _inherits(StreamProcessingError, _StripeError);
  function StreamProcessingError() {
    _classCallCheck(this, StreamProcessingError);
    return _possibleConstructorReturn(this, _getPrototypeOf(StreamProcessingError).apply(this, arguments));
  }
  return StreamProcessingError;
}(StripeError); // Method for formatting HTTP body for the multipart/form-data specification
// Mostly taken from Fermata.js
// https://github.com/natevw/fermata/blob/5d9732a33d776ce925013a265935facd1626cc88/fermata.js#L315-L343
var multipartDataGenerator = function multipartDataGenerator(method, data, headers) {
  var segno = (Math.round(Math.random() * 1e16) + Math.round(Math.random() * 1e16)).toString();
  headers['Content-Type'] = "multipart/form-data; boundary=".concat(segno);
  var buffer = Buffer.alloc(0);
  function push(l) {
    var prevBuffer = buffer;
    var newBuffer = l instanceof Buffer ? l : Buffer.from(l);
    buffer = Buffer.alloc(prevBuffer.length + newBuffer.length + 2);
    prevBuffer.copy(buffer);
    newBuffer.copy(buffer, prevBuffer.length);
    buffer.write('\r\n', buffer.length - 2);
  }
  function q(s) {
    return "\"".concat(s.replace(/"|"/g, '%22').replace(/\r\n|\r|\n/g, ' '), "\"");
  }
  var flattenedData = utils.flattenAndStringify(data);
  for (var k in flattenedData) {
    var v = flattenedData[k];
    push("--".concat(segno));
    if (v.hasOwnProperty('data')) {
      push("Content-Disposition: form-data; name=".concat(q(k), "; filename=").concat(q(v.name || 'blob')));
      push("Content-Type: ".concat(v.type || 'application/octet-stream'));
      push('');
      push(v.data);
    } else {
      push("Content-Disposition: form-data; name=".concat(q(k)));
      push('');
      push(v);
    }
  }
  push("--".concat(segno, "--"));
  return buffer;
};
var streamProcessor = function streamProcessor(method, data, headers, callback) {
  var bufferArray = [];
  data.file.data.on('data', function (line) {
    bufferArray.push(line);
  }).once('end', function () {
    var bufferData = Object.assign({}, data);
    bufferData.file.data = Buffer.concat(bufferArray);
    var buffer = multipartDataGenerator(method, bufferData, headers);
    callback(null, buffer);
  }).on('error', function (err) {
    callback(new StreamProcessingError({
      message: 'An error occurred while attempting to process the file for upload.',
      detail: err
    }), null);
  });
};
var multipartRequestDataProcessor = function multipartRequestDataProcessor(method, data, headers, callback) {
  data = data || {};
  if (method !== 'POST') {
    return callback(null, utils.stringifyRequestData(data));
  }
  var isStream = utils.checkForStream(data);
  if (isStream) {
    return streamProcessor(method, data, headers, callback);
  }
  var buffer = multipartDataGenerator(method, data, headers);
  return callback(null, buffer);
};
module.exports.multipartRequestDataProcessor = multipartRequestDataProcessor;